import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router';

import useResponsiveValue from '@app/hooks/useResponsiveValue';
import { turnOffGuideBanner } from '@app/store/guide/state';

function useOnboardingGuide() {
  const dispatch = useDispatch();
  const location = useLocation();
  const isMobileWidth = useResponsiveValue([true, true, false]);

  useEffect(() => {
    if (isMobileWidth) {
      dispatch(turnOffGuideBanner({ guideId: 'documents' }));
      dispatch(turnOffGuideBanner({ guideId: 'templates' }));
    }
  }, [dispatch, isMobileWidth, location.pathname]);
}

export default useOnboardingGuide;
